<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout column>
        <v-flex>
          <v-layout row wrap>
            <v-flex>
              <v-card raised>
                <v-card-title class="title">
                  Care User Profile
                </v-card-title>
                <v-card-text align=left>
                  <v-layout row>
                    <v-flex text-xs-left>Care Group: {{careUser.careGroup.name}}</v-flex>
                    <v-flex text-xs-right>Service: {{careUser.service.name}}</v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout row>
            <v-flex>
              <v-layout column>
                <v-flex>
                  <v-card color="transparent grey lighten-3">
                    <v-card-title class="subheading">Care User Info</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text align="left">
                      <v-layout row class="grey lighten-5">
                        <v-flex>
                          <v-text-field readonly label="First Name" v-model="careUser.firstName"></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-dialog v-model="dialog1">
                            <v-btn small icon slot="activator" v-if="this.shouldDisplay('/careUserUpdate')"><v-icon color="grey">edit</v-icon></v-btn>
                            <v-form v-model="valid">
                              <v-card>
                                <v-card-text>
                                  <v-text-field
                                    v-model="firstNameUpdate"
                                    label="First Name"
                                    type="text"
                                    hint="Please enter your first name here"
                                    :counter="45"
                                    maxlength="45"
                                    :rules="nameRules"
                                    required
                                    clearable
                                  ></v-text-field>
                                </v-card-text>
                                <small>*indicates required field</small>
                                <v-spacer></v-spacer>
                                <v-btn flat color="blue darken-1"
                                  @click.native="dialog1 = false">Close</v-btn>
                                <v-btn flat color="blue darken-1"
                                @click.native="update" :disable="!valid">Save</v-btn>
                              </v-card>
                            </v-form>
                          </v-dialog>
                      </v-flex>
                      </v-layout>
                      <v-layout row class="grey lighten-5">
                        <v-flex>
                          <v-text-field readonly label="Last Name" v-model="careUser.lastName"></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-dialog v-model="dialog2">
                            <v-btn small icon slot="activator" v-if="this.shouldDisplay('/careUserUpdate')"><v-icon color="grey">edit</v-icon></v-btn>
                            <v-form v-model="valid">
                              <v-card>
                                <v-card-text>
                                  <v-text-field
                                    v-model="lastNameUpdate"
                                    label="Last Name"
                                    type="text"
                                    hint="Please enter your last name here"
                                    :counter="45"
                                    maxlength="45"
                                    :rules="nameRules"
                                    required
                                    clearable
                                  ></v-text-field>
                                </v-card-text>
                                <small>*indicates required field</small>
                                <v-spacer></v-spacer>
                                <v-btn flat color="blue darken-1"
                                  @click.native="dialog2 = false">Close</v-btn>
                                <v-btn flat color="blue darken-1"
                                  @click.native="update" :disabled="!valid">Save</v-btn>
                              </v-card>
                            </v-form>
                          </v-dialog>
                      </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex>
                  <v-card color="transparent grey lighten-3">
                    <v-card-title class="subheading">Email</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text align=left>
                      <v-layout row class="grey lighten-5">
                        <v-flex>
                          <v-text-field readonly label="Email #1" v-model="careUser.Email1.email"></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-dialog v-model="dialog3">
                            <v-btn small icon slot="activator" v-if="this.shouldDisplay('/careUserUpdate')"><v-icon color="grey">edit</v-icon></v-btn>
                            <v-form v-model="valid">
                              <v-card>
                                <v-card-text>
                                  <v-text-field
                                    v-model="emailAddress1Update"
                                    label="Email #1"
                                    type="text"
                                    hint="Please enter your email here"
                                    :counter="45"
                                    maxlength="45"
                                    :rules="emailRules"
                                    required
                                    clearable
                                  ></v-text-field>
                                </v-card-text>
                                <small>*indicates required field</small>
                                <v-spacer></v-spacer>
                                <v-btn flat color="blue darken-1"
                                  @click.native="dialog3 = false">Close</v-btn>
                                <v-btn flat color="blue darken-1"
                                  @click.native="update" :disabled="!valid">Save</v-btn>
                              </v-card>
                            </v-form>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                      <v-layout row class="grey lighten-5">
                        <v-flex>
                          <v-text-field readonly label="Email #2" v-model="careUser.Email2.email"></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-dialog v-model="dialog4">
                            <v-btn small icon slot="activator" v-if="this.shouldDisplay('/careUserUpdate')"><v-icon color="grey">edit</v-icon></v-btn>
                            <v-form v-model="valid">
                              <v-card>
                                <v-card-text>
                                  <v-text-field
                                    v-model="emailAddress2Update"
                                    label="Email #2"
                                    type="text"
                                    hint="Please enter your email here"
                                    :counter="45"
                                    maxlength="45"
                                    :rules="emailRules"
                                    required
                                    clearable
                                  ></v-text-field>
                                </v-card-text>
                                <small>*indicates required field</small>
                                <v-spacer></v-spacer>
                                <v-btn flat color="blue darken-1"
                                  @click.native="dialog4 = false">Close</v-btn>
                                <v-btn flat color="blue darken-1"
                                  @click.native="update" :disabled="!valid">Save</v-btn>
                              </v-card>
                            </v-form>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout column>
                <v-flex>
                  <v-card flat color="transparent grey lighten-3">
                    <v-card-title class="subheading">Address</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text align=left>
                      <v-flex class="grey lighten-5">
                        <v-text-field readonly label="Unit Number" v-model="careUser.address.unitNumber"></v-text-field>
                      </v-flex>
                      <v-flex class="grey lighten-5">
                        <v-text-field readonly label="Street Address" v-model="careUser.address.streetAddress"></v-text-field>
                      </v-flex>
                      <v-flex class="grey lighten-5">
                        <v-text-field readonly label="City" v-model="careUser.address.city"></v-text-field>
                      </v-flex>
                      <v-flex class="grey lighten-5">
                      <v-text-field readonly label="Province" v-model="careUser.address.province"></v-text-field>
                      </v-flex>
                      <v-flex class="grey lighten-5">
                      <v-text-field readonly label="Postal Code" v-model="careUser.address.postalCode"></v-text-field>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-flex>
            </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout row>
            <v-flex>
              <v-card color="transparent grey lighten-3">
                <v-card-title class="subheading">Location Contact</v-card-title>
                <v-divider></v-divider>
                <v-card-text align=left>
                  <v-layout row class="grey lighten-5">
                    <v-flex>
                      <v-text-field readonly label="First Name" v-model="careUser.Location.firstName"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="grey lighten-5">
                    <v-flex>
                      <v-text-field readonly label="Last Name" v-model="careUser.Location.lastName"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="grey lighten-5">
                    <v-flex>
                      <v-text-field readonly label="Phone" v-model="careUser.Location.phone.phone"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="grey lighten-5">
                    <v-flex>
                      <v-text-field readonly label="Email" v-model="careUser.Location.email.email"></v-text-field>
                    </v-flex>
                        <v-flex>
                          <v-dialog v-model="dialogLocationEmail">
                            <v-btn small icon slot="activator" v-if="this.shouldDisplay('/careUserUpdate')"><v-icon color="grey">edit</v-icon></v-btn>
                            <v-form v-model="valid">
                              <v-card>
                                <v-card-text>
                                  <v-text-field
                                    v-model="locationEmailAddressUpdate"
                                    label="Location Contact Email"
                                    type="text"
                                    hint="Please enter location contact email here"
                                    :counter="45"
                                    maxlength="45"
                                    :rules="emailRules"
                                    required
                                    clearable
                                  ></v-text-field>
                                </v-card-text>
                                <small>*indicates required field</small>
                                <v-spacer></v-spacer>
                                <v-btn flat color="blue darken-1"
                                  @click.native="dialogLocationEmail = false">Close</v-btn>
                                <v-btn flat color="blue darken-1"
                                  @click.native="update" :disabled="!valid">Save</v-btn>
                              </v-card>
                            </v-form>
                          </v-dialog>
                        </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex>
              <v-card color="transparent grey lighten-3">
                <v-card-title class="subheading">Emergency Contact 1</v-card-title>
                <v-divider></v-divider>
                <v-card-text align=left>
                  <v-text-field readonly label="First Name" v-model="careUser.Emergency1.firstName"></v-text-field>
                  <v-text-field readonly label="Last Name" v-model="careUser.Emergency1.lastName"></v-text-field>
                  <v-text-field readonly label="Phone" v-model="careUser.Emergency1.phone.phone"></v-text-field>
                  <v-text-field readonly label="Email" v-model="careUser.Emergency1.email.email"></v-text-field>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex>
              <v-card color="transparent grey lighten-3">
                <v-card-title class="subheading">Emergency Contact 2</v-card-title>
                <v-divider></v-divider>
                <v-card-text align=left>
                  <v-text-field readonly label="First Name" v-model="careUser.Emergency2.firstName"></v-text-field>
                  <v-text-field readonly label="Last Name" v-model="careUser.Emergency2.lastName"></v-text-field>
                  <v-text-field readonly label="Phone" v-model="careUser.Emergency2.phone.phone"></v-text-field>
                  <v-text-field readonly label="Email" v-model="careUser.Emergency2.email.email"></v-text-field>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <div class="red--text" v-html="error"></div>
    </v-container>
  </div>
</template>

<script>
  import mixins from '@/mixins.js'
  import CareUserService from '@/services/CareUserService'

  export default {
    data () {
      return {
        name: this.$route.params.name,
        dialog1: false,
        dialog2: false,
        dialog3: false,
        dialog4: false,
        dialogLocationEmail: false,
        valid: false,
        error: '',
        phoneMask: 'phone',
        nameRules: [
          (v) => !!v || 'This field is required',
        ],
        phoneRules: [
          (v) => !!v || 'Phone is required',
          (v) => /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) || 'Phone must be 10 digits'
        ],
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],

        firstNameUpdate: '',
        lastNameUpdate: '',
        emailAddress1Update: '',
        emailAddress2Update: '',
        locationEmailAddressUpdate: '',

        careUser: {
          firstName: '',
          lastName: '',
          phone: {
            phone: ''
          },
          careGroup: {
            name: ''
          },
          service: {
            name: ''
          },
          Email1: {
            email: ''
          },
          Email2: {
            email: ''
          },
          Emergency1: {
            phone: {
              phone: ''
            },
            email: {
              email: ''
            }
          },
          Emergency2: {
            phone: {
              phone: ''
            },
            email: {
              email: ''
            }
          },
          address: {
            unitNumber: '',
            streetAddress: '',
            city: '',
            province: '',
            postalCode: ''
          },
          Location: {
            firstName: '',
            lastName: '',
            phone: {
              phone: ''
            },
            email: {
              email: ''
            }
          }
        }
      }
    },
    mixins: [mixins],
    methods: {
      async update() {
        this.dialog1 = false
        this.dialog2 = false
        this.dialog3 = false
        this.dialog4 = false
        this.dialogLocationEmail = false
        try {
          const response = await CareUserService.update({
            careUserId: this.careUserId,
            firstName: this.firstNameUpdate,
            lastName: this.lastNameUpdate,
            // phoneNumber: this.phoneNumberUpdate,
            // unitNumber: this.unitNumberUpdate,
            // streetAddress: this.streetAddressUpdate,
            // city: this.cityUpdate,
            // province: this.provinceUpdate,
            // postalCode: this.postalCodeUpdate,
            emailAddress1: this.emailAddress1Update,
            emailAddress2: this.emailAddress2Update,
            // careGroupId: '2',
            // serviceId: '3',
            // emergency1firstName: this.emergency1firstNameUpate,
            // emergency1lastName: this.emergency1lastNameUpdate,
            // emergency1phoneNumber: this.emergency1phoneNumberUpdate,
            // emergency1emailAddress: this.emergency1emailAddressUpdate,
            // emergency2firstName: this.emergency2firstNameUpdate,
            // emergency2lastName: this.emergency2lastNameUpdate,
            // emergency2phoneNumber: this.emergency2phoneNumberUpdate,
            // emergency2emailAddress: this.emergency2emailAddressUpdate,
            // locationFirstName: this.locationFirstNameUpdate,
            // locationLastName: this.locationLastNameUpdate,
            // locationPhoneNumber: this.locationPhoneNumberUpdate,
            locationEmailAddress: this.locationEmailAddressUpdate
          })
          this.error = "Update Successful"
          this.careUser.firstName = this.firstNameUpdate
          this.careUser.lastName = this.lastNameUpdate
          this.careUser.Email1.email = this.emailAddress1Update
          this.careUser.Email2.email = this.emailAddress2Update
          this.careUser.Location.email.email = this.locationEmailAddressUpdate
        } catch (error) {
            this.error = this.handleError(error)
        }
      }
    },
    async mounted () {
      try {
        this.error = ''
        const careUserId = this.$route.params.id
        this.careUser = (await CareUserService.show({careUserId})).data
        this.firstNameUpdate = this.careUser.firstName
        this.lastNameUpdate = this.careUser.lastName
        this.emailAddress1Update = this.careUser.Email1.email
        this.emailAddress2Update = this.careUser.Email2.email
        this.locationEmailAddressUpdate = this.careUser.Location.email.email
        this.careUserId = this.careUser.careUserId
      } catch (error) {
          this.error = this.handleError(error)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/CareUser/CareUserTabProfile.vue